import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './GrossReceiptsComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';

function GrossReceiptsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('GrossReceiptsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const sumAllFields = () => {
        
        // eslint-disable-next-line no-unused-expressions
        const sumAll = modelVM.value.booCamRecFie + modelVM.value.camRecFie + modelVM.value.cloRecFie + modelVM.value.estRecFie +
            modelVM.value.fooRecFie + modelVM.value.jeaCloRecFie + modelVM.value.liqRecFie + modelVM.value.lotRecFie +
            modelVM.value.memRecFie + modelVM.value.proSalRecFie + modelVM.value.recRecFie + modelVM.value.inhouManProRecFie +
            modelVM.value.stuRecFie + modelVM.value.sumCamFie + modelVM.value.supRecFie + modelVM.value.swiCloRecFie +
            modelVM.value.tanRecFie + modelVM.value.traRecFie + modelVM.value.othMisRecFie;

            _.set(modelVM, 'totYeaGroRecFie.value', sumAll);

            return sumAll;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifOthMisRecplespeFie: {
            visible: !_.isUndefined(modelVM.value.othMisRecFie) && modelVM.value.othMisRecFie > 0
        },
        totYeaGroRecFie: {
            value: sumAllFields()
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

GrossReceiptsComponent.propTypes = wizardProps;
export default withRouter(GrossReceiptsComponent);
